import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import moment from 'moment-timezone';
import { memberActionCreators } from '../../stores/lis-members-store';
import { sessionActionCreators } from '../../stores/lis-session-store';
import { navActionCreators } from '../../stores/lis-nav-store';
import { collectionActionCreators } from '../../stores/lis-collection-store';
const BILL_COLLECTION_AUTHOR = "LegislationCollections";
import { CustomOption } from '../../services/legislation-helper-service';
import ReportMaker from './lis-bill-search/lis-report-maker';

import { cancelRequest } from '../../services/request.service';

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px'
    }),
}


class PublicMemberLegislation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            chamberOptions: [
                { label: 'Delegates', value: 'H' },
                { label: 'Senators', value: 'S' }
            ],
            hideBills: [],
            collapseAll: false,
            showPrefileOnly: false,
            navigateTo: this.props.location.search?.replace('?', '') ?? '',
            checkedBills: new Map(), // its either this or a matrix
            collections: [],
            selectedWatchlists: [],
            menuIsOpen: false,
            collectionIsSaving: false,
            newNote: {
                Name: '',
                WatchListID: -1,
                isNew: true,
                value: '',
                Description: ''
            },
            selectAll: [],
            showReportMaker: false,
            focusAnnouncement: ''
        };

        this.setupDoc = this.setupDoc.bind(this);
        this.handleChamberChange = this.handleChamberChange.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
        this.toggleRow = this.toggleRow.bind(this);
        this.toggleShowPrefile = this.toggleShowPrefile.bind(this);

        this.addToWatchlists = this.addToWatchlists.bind(this);
        this.handleAddToWatchlists = this.handleAddToWatchlists.bind(this);
        this.handleWatchlistChange = this.handleWatchlistChange.bind(this);
        this.toggleMenuIsOpen = this.toggleMenuIsOpen.bind(this);
        this.handleIsRelated = this.handleIsRelated.bind(this);
        this.manuallyFocusTheNextOne = this.manuallyFocusTheNextOne.bind(this);
        this.handleSelectAllForMember = this.handleSelectAllForMember.bind(this);

        this.selectRef = React.createRef();
    }

    setupDoc(sessionCode) {
        this.setState({
            isLoaded: false
        });
        this.props.actions.getSessionByCode(sessionCode).then(() => {
            let chamberCode = this.props.match.params.chambercode;
            const sessionData = this.props.session.selectedSession;
            this.props.actions.getMemberLegislation('sessionID=' + sessionData.SessionID + '&chamberCode=' + chamberCode)
                .then(() => {
                    if (this.props.members.memberLegislationError) {
                        throw this.props.members.memberLegislationError;
                    }
                    this.setState({
                        checkedBills: new Map(),
                        collapseAll: true,
                    });
                    const params = 'sessionID=' + sessionData.SessionID + '&chamberCode=' + chamberCode + '&contactTypeID=8';
                    this.props.actions.getMemberContact(params).then(() =>
                        this.setState({
                            members: this.props.members.memberContactData,
                            hideBills: new Array(this.props.members.memberContactData.length).fill(true),
                            selectAll: new Array(this.props.members.memberContactData.length).fill(false),
                            isLoaded: true
                        })
                    )
                })
                .catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    this.setState({
                        isLoaded: true,
                        message: err.toString()
                    });
                    console.log(err.toString());
                });
            if (this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR)) {
                this.props.actions.getCollections("?SessionID=" + sessionData.SessionID)
                    .then(() => {
                        this.setState({
                            collections: this.props.collection.collections
                        })
                    })
            }
        });
    }

    handleChamberChange(value) {
        this.props.history.push('/session-details/' + this.props.nav.session + '/member-legislation/' + value.value);
    }

    toggleAll() {
        const opposite = !this.state.collapseAll;

        let hideBills = [...this.state.hideBills];
        hideBills.fill(true);
        this.state.members.forEach((m, i) => {
            hideBills[i] = opposite;
        })
        this.setState({
            collapseAll: opposite,
            hideBills: hideBills
        });
    }

    toggleRow(index) {
        let hideBills = [...this.state.hideBills];
        let not = !hideBills[index]
        hideBills[index] = not;
        const holder = document.getElementsByClassName('member-legislation');
        const current = holder[0]?.children[index + 1]; // flex-row
        const top = current.getBoundingClientRect().top;
        this.setState({
            hideBills: hideBills
        }, () => {
            if (not && top < 0) {
                // I don't know if the timeouts are needed, but at this point I don't care
                setTimeout(() => current.scrollIntoView());
                const headerHeight = document.getElementsByClassName('member-legislation-controls')[0].clientHeight ?? 0;
                const renderedHeight = headerHeight -
                    (window.innerWidth > 900 ? 0 : 55); // Only part of the top bar is shown on mobile
                setTimeout(() => window.scrollBy(0, - renderedHeight));
            }
        });
    }

    toggleShowPrefile() {
        if (!this.state.showPrefileOnly) {
            // Don't keep checked bills that you won't be able to see
            const legislation = this.props.members.memberLegislation.map(m => m.Legislation).flat();
            const prefiledLegislationNumbers = legislation.filter(l => !l.IsPrefile);
            const newCheckedBills = new Map(this.state.checkedBills);
            prefiledLegislationNumbers.forEach(l => newCheckedBills.delete(l.LegislationNumber));
            this.setState({
                checkedBills: newCheckedBills
            });
        }
        this.setState(state => ({
            showPrefileOnly: !state.showPrefileOnly
        }));
    }

    componentDidUpdate(prevProps) {
        // Setup the page if the global selected session changes. Change the URL to reflect the session change
        if (prevProps.nav.session !== this.props.nav.session) {
            this.props.history.push('/session-details/' + this.props.nav.session + '/member-legislation/' + this.props.match.params.chambercode);
            this.setupDoc(this.props.nav.session);
        } else if (this.props.nav.session !== this.props.match.params.sessioncode) {
            // If the url changes then update the global selected session with whatever the url is
            if (this.props.match.params.sessioncode) {
                this.props.actions.changeSession(this.props.match.params.sessioncode);
            }
        } else if (this.props.match.params.chambercode !== prevProps.match.params.chambercode) {
            this.setupDoc(this.props.nav.session);
        } else if (this.props.members.memberContactData?.length > 0 && this.state.navigateTo !== '' && this.state.isLoaded) {
            const element = document.getElementById(this.state.navigateTo);
            if (element) {
                let elementToScrollTo = element.previousElementSibling;
                const memberLegislation = this.props.members.memberLegislation.find(m => m.MemberNumber === this.state.navigateTo)?.Legislation || [];
                if (memberLegislation.length === 0) {
                    elementToScrollTo = elementToScrollTo?.previousElementSibling;
                }
                elementToScrollTo?.scrollIntoView(); // Otherwise the header goes over the name if there is no legislation
                const hideBills = this.props.members.memberContactData.map(m => m.MemberNumber !== this.state.navigateTo);
                this.setState({
                    hideBills
                });
                this.setState({ navigateTo: '' });

            }
        }
    }

    componentDidMount() {
        //Update the session selector component, which will run componentDidUpdate and call setupDoc on its own
        const sessionCode = this.props.match.params.sessioncode
        if (sessionCode) {
            if (this.props.nav.session !== sessionCode) {
                this.props.actions.changeSession(sessionCode)
            } else {
                this.setupDoc(sessionCode);
            }
        }
    }

    componentWillUnmount() {
        cancelRequest();
    }

    addToWatchlists(watchlists, callback) {
        let billsToAdd = [];

        const legislation = this.props.members.memberLegislation.map(m => m.Legislation).flat()
            .map(m => ({
                LegislationID: m.LegislationID,
                LegislationNumber: m.LegislationNumber,
                SessionID: m.SessionID,
            }));
        for (let [key, value] of this.state.checkedBills) {
            if (value) {
                billsToAdd.push(legislation.find(l => l.LegislationNumber === key));
            }
        }

        let duplicatedBills = [];
        watchlists.forEach(watchlist => {
            billsToAdd.forEach(bill => {
                if (watchlist.__isNew__) {
                    watchlist.Name = watchlist.label;
                    watchlist.Description = `Created on ${moment().tz().format('MM/DD/YYYY')}`;
                    watchlist.WatchListLegislation = [];
                    delete watchlist.label;
                    delete watchlist.__isNew__;
                    delete watchlist.value;
                }
                // Make sure the bill isn't already a part of the watchlist
                if (!watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID) || watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID).DeletionDate) {
                    watchlist.WatchListLegislation.push({
                        LegislationID: bill.LegislationID,
                        LegislationNumber: bill.LegislationNumber,
                        Sessions: [{ SessionID: bill.SessionID }],
                        WatchListID: watchlist.WatchListID,
                        Note: bill.Note
                    });
                } else {
                    duplicatedBills.push({ "Watchlist": watchlist.Name, "LegislationNumber": bill.LegislationNumber });
                }
            });
        })

        this.setState({
            collectionIsSaving: true
        }, () => {
            let collections = [...this.state.collections];
            this.props.actions.saveCollections({ WatchLists: watchlists })
                .then(() => {
                    let watchlistSave = [...this.props.collection.collectionSave];
                    let savedCollectionIndex;
                    watchlistSave.forEach(res => {
                        if (!collections.find(coll => coll.WatchListID === res.WatchListID)) {
                            collections.unshift(res);
                            savedCollectionIndex = 0;
                        } else {
                            savedCollectionIndex = collections.findIndex(coll => coll.WatchListID === res.WatchListID);
                            collections[savedCollectionIndex] = res;
                        }
                        res.WatchListLegislation = res.WatchListLegislation || [];
                        res.NotificationCriterias = res.NotificationCriterias || [];
                    })

                    this.setState({
                        collectionIsSaving: false,
                        collections: collections,
                        selectedCollection: watchlists.length === 1 ? collections[savedCollectionIndex] : this.state.selectedCollection,
                        selectedCollectionIndex: watchlists.length === 1 ? savedCollectionIndex : this.state.selectedCollectionIndex,
                        checkedBills: new Map()
                    });
                    if (duplicatedBills.length) {
                        this.props.actions.makeToast([{ message: (new Set(duplicatedBills.map(b => b.LegislationNumber)).size === 1 ? (duplicatedBills[0].LegislationNumber + " is ") : "Multiple added bills were ") + "already in " + (watchlists.length === 1 ? "this watchlist. " : "one or more of these watchlists. ") + (watchlists.length === 1 ? ((billsToAdd.length - duplicatedBills.length) + " bills were added to your watchlist " + watchlists[0].Name) : "All other bills were added."), type: "warning", long: true }]);
                    } else {
                        this.props.actions.makeToast([{ message: (billsToAdd.length === 1 ? billsToAdd[0].LegislationNumber + " was " : billsToAdd.length + " bills were ") + "added to your watchlist" + (watchlists.length > 1 ? "s" : (" " + watchlists[0].Name)), type: "success" }]);
                    }
                    if (callback) {
                        callback(collections)
                    }
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        collectionIsSaving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        });
    }

    handleWatchlistChange(val) {
        this.setState({
            selectedWatchlists: val ? val : []
        });
    }

    handleAddToWatchlists() {
        this.addToWatchlists(this.state.selectedWatchlists, (saveResultCollections) => {
            let showPopup = { ...this.state.showPopup };
            let watchlists = [...this.state.selectedWatchlists];

            for (let i = 0; i < watchlists.length; i++) {
                const associatedWatchlist = saveResultCollections.find(c => c.WatchListID === watchlists[i].WatchListID);
                if (associatedWatchlist && associatedWatchlist.ModificationDate !== watchlists[i].ModificationDate) {
                    watchlists[i] = associatedWatchlist
                };
            }

            this.setState({ selectedWatchlists: watchlists, showPopup })
        });
    }

    toggleMenuIsOpen(value) {
        if (value === undefined) {
            this.setState({ menuIsOpen: !this.state.menuIsOpen });
        } else {
            this.setState({ menuIsOpen: value });
        }
    }

    handleIsRelated(e, direction) {
        const relatedTarget = e.relatedTarget
        if (relatedTarget === null) {
            this.toggleMenuIsOpen(false);
        }
        const isParOfTheSelect = (el) => {
            let parent = el?.parentElement;
            if (parent) {
                if (parent.id === 'sr-watchlist-name-control-bad') {
                    return true;
                } else {
                    return isParOfTheSelect(parent);
                }
            } else {
                return false;
            }
        }
        const shouldClose = isParOfTheSelect(relatedTarget);
        if (shouldClose) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (shouldClose && direction) {

        } else {
            this.toggleMenuIsOpen(shouldClose);
        }
    }

    manuallyFocusTheNextOne(direction) {
        // The id is different depending on where the Modal is ...
        const mainThing = document.getElementById('sr-watchlist-name-control-bad');
        mainThing?.getElementsByTagName('input')[0]?.focus();
        document.getElementById('react-select-3-input')?.focus();
        if (direction === 'down') {
            this.selectRef?.current?.select?.focusOption('down');
        } else if (direction === 'up') {
            this.selectRef?.current?.select?.focusOption('up');
        }
    }

    handleSelectAllForMember(memberIndex, memberBills) {
        let newCheckedBills = new Map(this.state.checkedBills);
        if (this.state.selectAll[memberIndex]) {
            memberBills.forEach(leg => {
                newCheckedBills.delete(leg.LegislationNumber)
            })
        } else {
            memberBills.forEach(leg => {
                newCheckedBills.set(leg.LegislationNumber, true)
            })
        }
        this.setState({
            selectAll: this.state.selectAll.map((s, i) => s = i === memberIndex ? !s : s),
            checkedBills: newCheckedBills
        });
    }

    render() {
        const { isLoaded, message, chamberOptions, hideBills, collapseAll } = this.state;
        const showPrefiled = !this.props.session.selectedSession.LegacySessionID; // Ideally we show it for 20242, but the data isn't there
        if (message) {
            return (<div className="center">{message}</div>)
        }
        const somethingChecked = Array.from(this.state.checkedBills.values()).find(v => v);

        const toggleHeaderButton = (memberIndex) =>
            <button aria-label={"Toggle " + (this.state.members[memberIndex].MemberDisplayName ? this.state.members[memberIndex].MemberDisplayName + "'s Bills" : "Bills")} aria-expanded={!!hideBills[memberIndex]} onClick={() => this.toggleRow(memberIndex)} className={hideBills[memberIndex] ? "arrow-down" : "arrow-up"}>Show bills</button>

        const signedIn = !!this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR);
        return (
            <>
                {this.state.showReportMaker &&
                    <ReportMaker
                        toggleReportMaker={() => this.setState({ showReportMaker: !this.state.showReportMaker })}
                        selectedCollection={{
                            Name: 'Report on Member Legislation as Chief Patron'
                        }}
                        billList={(() => {
                            const leg = this.props.members.memberLegislation.map(m => m.Legislation).flat();
                            const bills = [];
                            this.state.checkedBills.forEach((v, k) => {
                                if (v) {
                                    bills.push(leg.find(l => l.LegislationNumber === k))
                                }
                            })
                            return bills;
                        })()}
                        reportTitle={'Report on Member Legislation as Chief Patron'}
                        history={this.props.history}
                    />
                }
                <h2 style={{ margin: 0, padding: '0 0 5px' }}>Chief Patron Legislation</h2>
                <span aria-live="polite" className="sr-only" style={{ position: 'absolute', left: '-9999px' }}>{this.state.focusAnnouncement}</span>
                <div className={"toolbar minutes-toolbar dlas-forms flex-row member-legislation-controls " + (!signedIn && 'not-signed-in')}>
                    <div className='original-controls'>
                        <label htmlFor="chamber-dropdown" className="screen-reader-only">Chamber</label>
                        <Select
                            aria-label="Chamber Selector"
                            value={chamberOptions.find(chamber => chamber.value === this.props.match.params.chambercode)}
                            options={chamberOptions}
                            id="chamber-dropdown"
                            onChange={this.handleChamberChange}
                            isDisabled={!isLoaded}
                            classNamePrefix='no-width-dropdown-input'
                            onFocus={() => {
                                this.setState({
                                    focusAnnouncement: `Current selection is ${chamberOptions.find(chamber => chamber.value === this.props.match.params.chambercode).label}. ${chamberOptions.length} options available.`
                                })
                            }}
                            onBlur={() => this.setState({ focusAnnouncement: '' })}
                        />
                        {showPrefiled ? <div className="checkbox">
                            <input id="sr-only-prefile" style={{ verticalAlign: 'bottom' }} onChange={this.toggleShowPrefile} type="checkbox" checked={this.state.showPrefileOnly} disabled={!this.state.isLoaded} />
                            <label htmlFor="sr-only-prefile">Only Show Prefile</label>
                        </div>
                            : <div />
                        }
                    </div>
                    {isLoaded && signedIn ?
                        <div className="dlas-forms collection-controls">
                            <label id='add-watchlist-label'>Add bills to watchlist(s)</label>
                            <Select
                                aria-label='Add bill to watchlist selector'
                                ref={this.selectRef}
                                id="sr-watchlist-name-control-bad"
                                styles={selectStyle}
                                options={[{ isNew: true }].concat(this.state.collections)}
                                getOptionLabel={opt => opt.label || `${opt.Name} ${opt.Description && `- ${opt.Description}`}`}
                                getOptionValue={opt => opt.value || opt.WatchListID}
                                value={this.state.selectedWatchlists}
                                onChange={e => { if (Array.isArray(e) && e.find(ee => ee.isNew)) { return null; } this.toggleMenuIsOpen(false); this.handleWatchlistChange(e) }}
                                createOptionPosition="first"
                                formatCreateLabel={input => <span>Create new: {input}</span>}
                                isMulti
                                placeholder='Select or create ...'
                                classNamePrefix='no-width-dropdown-input'
                                components={{ 'Option': CustomOption }}
                                updateNew={this.handleWatchlistChange}
                                toggleMenuIsOpen={this.toggleMenuIsOpen}
                                menuIsOpen={this.state.menuIsOpen}
                                onMenuOpen={e => { this.toggleMenuIsOpen(!this.state.menuIsOpen) }}
                                onBlur={e => { this.handleIsRelated(e) }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' && !this.state.menuIsOpen) {
                                        e.preventDefault();
                                        const arrowDownEvent = new KeyboardEvent('keydown', {
                                            key: 'ArrowDown',
                                            code: 'ArrowDown',
                                            keyCode: 40,
                                            which: 40,
                                            bubbles: true
                                        });
                                        e.currentTarget.dispatchEvent(arrowDownEvent);
                                    }
                                    // So, arrow keys let you navigate through the options. But we want to be able to auto tab into the new input.
                                    // This works for the most part, until you tab into the select initially. Then you need to focus on that specifically.
                                    if (e.key === 'Tab' && this.selectRef?.current?.select?.state?.focusedOption?.isNew) {
                                        e.preventDefault();
                                        document.getElementById('add-new')?.focus();
                                    } else if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                                        const current = this.selectRef?.current?.select?.state?.focusedOption?.WatchListID;
                                        const menuOptions = this.selectRef?.current?.select?.state?.menuOptions?.render;
                                        if (menuOptions && menuOptions.length > 1 && current) {
                                            const index = menuOptions.findIndex(o => o.data?.WatchListID === current);
                                            if (index === 1 && e.key === 'ArrowUp') {
                                                this.selectRef?.current?.select?.focusOption('up');
                                                setTimeout(() => document.getElementById('add-new')?.focus())
                                            } else if (index === menuOptions.length - 1 && e.key === 'ArrowDown') {
                                                this.selectRef?.current?.select?.focusOption('down');
                                                setTimeout(() => document.getElementById('add-new')?.focus())
                                            }
                                        } else if (menuOptions && this.selectRef?.current?.select?.state?.focusedOption === undefined && e.key === 'ArrowDown') {
                                            setTimeout(() => document.getElementById('add-new')?.focus())
                                        }
                                    }
                                }}
                                manuallyFocusTheNextOne={this.manuallyFocusTheNextOne}
                                handleIsRelated={this.handleIsRelated}
                                onFocus={() =>
                                    this.setState({
                                        focusAnnouncement: `Current selection is ${this.state.selectedWatchlists.map(x => x.Name + " " + x.Description).join(', ')}. ${[{ isNew: true }].concat(this.state.collections).length} options available.`
                                    })
                                }
                                onBlur={() => this.setState({ focusAnnouncement: '' })}
                            />
                            <div className="inline-list">
                                {this.props.collectionIsSaving ?
                                    <div><span className="small-spinner"></span></div>
                                    :
                                    <React.Fragment>
                                        <button disabled={this.state.selectedWatchlists.length === 0 || !somethingChecked} className="button add-watchlist" type="button" onClick={() => this.handleAddToWatchlists()} title={somethingChecked ? 'Add to Watchlist' : 'A bill and watchlist must be selected'}>Add</button>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        : <div />
                    }
                    {isLoaded && <div>
                        <button className='button primary' onClick={() => this.setState({ showReportMaker: !this.state.showReportMaker })} disabled={!somethingChecked} title={somethingChecked ? 'Create Report' : 'A bill must be selected'}>Create Report</button>
                    </div>
                    }
                </div>
                {isLoaded ?
                    <div className={"collapsible-table member-legislation " + (!signedIn && 'not-signed-in')}>
                        <div className="flex-row">
                            <div></div>
                            <button aria-label="Toggle Show All Bills" type="button" onClick={this.toggleAll} className="button-link">{collapseAll ? "Show Bills" : "Hide Bills"} +/-</button>
                        </div>
                        {this.state.members.map((member, memberIndex) => {
                            const legislation = this.props.members.memberLegislation.find(m => m.MemberNumber === member.MemberNumber)?.Legislation || [];
                            const totalBills = legislation.length;
                            const memberBills = this.state.showPrefileOnly ? legislation.filter(leg => leg.IsPrefile) : legislation;
                            let prefiledBills = 0;
                            let memberSpan;
                            if (showPrefiled) {
                                prefiledBills = legislation.filter(leg => leg.IsPrefile).length;
                                const nonPrefiledBills = totalBills - prefiledBills;
                                memberSpan = <span onClick={() => totalBills > 0 && this.toggleRow(memberIndex)}>{`Prefiled: ${prefiledBills} / Not Prefiled: ${nonPrefiledBills} / Total: ${totalBills}`}</span>
                            } else {
                                memberSpan = <span onClick={() => totalBills > 0 && this.toggleRow(memberIndex)}>{`Total Bills: ${totalBills}`}</span>
                            }

                            return (<div id={member.MemberNumber} key={memberIndex}>
                                <div className={(!hideBills[memberIndex] ? "opened " : '') + "flex-row section-header"}>
                                    <div className='internal-grid'>
                                        <div>
                                            <span>
                                                <Link className='member-name' to={`/session-details/${this.props.nav.session}/member-information/${member.MemberNumber}/member-details`}>
                                                    {member.MemberDisplayName}
                                                </Link>
                                            </span>
                                        </div>
                                        <Link to={'/vote-search/' + this.props.nav.session + '/' + member.MemberNumber}>Votes</Link>
                                        <div className="extra-info">
                                            {memberSpan}
                                            {toggleHeaderButton(memberIndex)}
                                        </div>
                                    </div>
                                    <div className='external-toggle'>
                                        {toggleHeaderButton(memberIndex)}
                                    </div>
                                </div>
                                {!hideBills[memberIndex] ? showPrefiled && prefiledBills === 0 && this.state.showPrefileOnly ?
                                    <div className="section-body empty-body">
                                        <div className="section-row">No prefiled legislation.</div>
                                    </div>
                                    :
                                    <div className={(!hideBills[memberIndex] ? "opened " : '') + "section-body"}>
                                        {memberBills.length > 0 ?
                                            <div className='select-all-container'>
                                                <input aria-label={`select all bills for ${member.MemberDisplayName}`} type='checkbox' value={this.state.selectAll[memberIndex]} onClick={() => this.handleSelectAllForMember(memberIndex, memberBills)} />
                                                <label> Select All</label>
                                            </div>
                                            : <div style={{ paddingTop: '5px', paddingBottom: '5px', borderBottom: '1px solid #e8e8e8' }}>
                                                No introduced legislation.
                                            </div>
                                        }
                                        {memberBills.map((leg, legIndex) =>
                                            <div key={legIndex} className="section-row inner-grid small-two-one">
                                                <div>
                                                    <input aria-label={`${leg.LegislationNumber} checkbox`} type='checkbox' style={{ marginRight: '5px' }} checked={!!this.state.checkedBills.get(leg.LegislationNumber)}
                                                        onClick={() => this.setState({
                                                            checkedBills: new Map(this.state.checkedBills.set(leg.LegislationNumber, !this.state.checkedBills.get(leg.LegislationNumber)))
                                                        })} readOnly />
                                                    <Link to={`/bill-details/${leg.SessionCode}/${leg.LegislationNumber}`}>{leg.LegislationNumber}</Link>
                                                </div>
                                                <span className='catchline' dangerouslySetInnerHTML={{ __html: leg.Description }} />
                                                <span style={{ textAlign: 'right' }} className="prefileness txt-greyed">{`${showPrefiled ? leg.IsPrefile ? "Prefiled" : "Not Prefiled" : ''}`}{showPrefiled && <span style={{ color: '#767676' }}> |</span>} {`${leg.LegislationStatus}`}</span>
                                            </div>
                                        )}
                                    </div>
                                    :
                                    <div className="section-body">
                                        <div className="section-row"></div>
                                    </div>
                                }
                            </div>)
                        })}
                    </div>
                    :
                    <div className="center-spinner spinner">Loading...</div>
                }
            </>
        );
    }
}

export default connect(
    (state) => {
        const { members, session, nav, collection, login } = state;
        return {
            members,
            session,
            nav,
            collection,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, memberActionCreators, sessionActionCreators, navActionCreators, collectionActionCreators), dispatch)
        }
    }
)(PublicMemberLegislation)
